import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { FRONTEND_DEFAULT_MATCH_ROUTE } from '../utils/constants'

/**
 * Redirects authenticated users from "/" to the default in-play dashboard.
 */
const DashboardRedirect = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(FRONTEND_DEFAULT_MATCH_ROUTE, { replace: true })
  }, [navigate])

  return null
}

export default DashboardRedirect
